import { take, all, fork, call } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import firebase from 'firebase/app'
import utils from '../utils'

const { Notification } = window

const vapidKey =
  utils.constants.env === 'PRD'
    ? 'BJv76Vw2OOuKIt0XAf19qRxrYvC5uCL_2eionuldNSrOTp-OClw_3p0zc7C6LFl2dEVRULYYLmeY-JmAXkGvEjw'
    : 'BAY4rQXZzPFdXmUKvs5PR53pC2C_zuor26-QAD4N4YUBhrPLGOfKvYR9wRiRWaIYsGevpbL3wjjhgoRVt4MeE7Y'

const eventListener = eventName =>
  eventChannel(emit => {
    // listener function in redux saga
    const subscriber = firebase.messaging()[eventName](event => {
      emit(event)
    })

    return () => {
      subscriber()
    }
  })

function* noticationSubscription(type = 'subscribe') {
  try {
    const messaging = firebase.messaging()
    const token = yield call([messaging, messaging.getToken])

    if (token) {
      const topic = 'webpush'
      const tokens = [token]
      const funtionName = `${type}MessageTopic`

      const callable = firebase
        .app()
        .functions('asia-northeast1')
        .httpsCallable(funtionName)

      yield fork(callable, { tokens, topic })
    }
  } catch (error) {
    console.error(error)
  }
}

function* tokenRefresh() {
  const listener = yield call(eventListener, 'onTokenRefresh')

  try {
    while (true) {
      yield take(listener)
      yield fork(noticationSubscription)
    }
  } finally {
    listener.close()
  }
}

function* onMessage() {
  const audio = new Audio(require('../assets/notification.mp3'))
  const audioFinished = new Audio(require('../assets/notification-success.mp3'))

  const listener = yield call(eventListener, 'onMessage')

  try {
    while (true) {
      const payload = yield take(listener)

      if (payload.data.type === 'NEW_ORDER' || payload.data.type === 'NO_DRIVER') {
        audio.play()
      } else if (payload.data.type === 'DELIVERED') {
        audioFinished.play()
      }
    }
  } finally {
    listener.close()
  }
}

export function* handleNotification(subscribe) {
  try {
    firebase.messaging().usePublicVapidKey(vapidKey)

    const permission = yield call([Notification, Notification.requestPermission])

    if (permission === 'granted') {
      const actions = [fork(noticationSubscription, subscribe ? 'subscribe' : 'unsubscribe')]

      if (subscribe) {
        actions.push(fork(tokenRefresh))
        actions.push(fork(onMessage))
      }

      yield all(actions)
    }
  } catch (err) {
    console.log(err)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/notificationSaga.js